import { type ReactNode } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import { AuthProvider, useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";

function NavBar() {
  const { me, logout } = useAuth();
  if (!me) return null;
  return (
    <header className="border-b bg-card">
      <div className="container flex h-14 items-center justify-between">
        <div className="flex items-center gap-6">
          <Link to="/dashboard" className="font-semibold">
            Spider Admin
          </Link>
          <nav className="flex gap-4 text-sm text-muted-foreground">
            <Link to="/dashboard" className="hover:text-foreground">
              Dashboard
            </Link>
            {me.is_admin && (
              <>
                <Link to="/admin/users" className="hover:text-foreground">
                  Users
                </Link>
                <Link to="/admin/keys" className="hover:text-foreground">
                  All keys
                </Link>
                <Link to="/admin/usage" className="hover:text-foreground">
                  Usage
                </Link>
                <Link to="/admin/revenue" className="hover:text-foreground">
                  Ertrag
                </Link>
              </>
            )}
          </nav>
        </div>
        <div className="flex items-center gap-3 text-sm">
          <span className="text-muted-foreground">{me.email}</span>
          <Button variant="outline" size="sm" onClick={() => void logout()}>
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
}

function ProtectedShell({ children }: { children: ReactNode }) {
  const { me, isLoading } = useAuth();
  const path = useRouterState({ select: (s) => s.location.pathname });
  if (path === "/login") return <>{children}</>;
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Lade…
      </div>
    );
  }
  if (!me) {
    return <>{children}</>;
  }
  return (
    <>
      <NavBar />
      <main className="container py-6">{children}</main>
    </>
  );
}

export function RootLayout({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <ProtectedShell>{children}</ProtectedShell>
    </AuthProvider>
  );
}
